import { Button } from "@/components/common/Button";
import { useTranslation } from "react-i18next";

const WeeklyProgress = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center bg-bg rounded-[0.75rem]">
      <div className="w-full flex items-center justify-start px-4 pt-3 gap-2">
        <p className="text-[1.25rem] leading-[1.5625rem] text-text font-semibold capitalize">
          {t("bonus-page.match_up")}
        </p>
        <Button size="small" mode="bezeled" text={t("bonus-page.promo")} />
      </div>
      <div className="w-full flex justify-between px-4 pt-3 pb-5 gap-0.5">
        <p className="text-[1rem] leading-[1.25rem] text-text font-semibold capitalize">
          {t("bonus-page.31_oct")}
        </p>
      </div>
    </div>
  );
};

export default WeeklyProgress;
